import script from "./ArgonCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./ArgonCheckbox.vue?vue&type=style&index=0&id=79ba88df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ba88df"]])

export default __exports__